import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CellsLine from '../views/CellsLine.vue'
import PersonCenter from '../views/PersonCenter.vue'
import SearchView from '../views/SearchView.vue'
import ShopView from '../views/ShopView.vue'
import ShopCartView from '../views/ShopCartView.vue'
import UserCenter from '../views/person/UserCenter.vue'
import UserInfoView from '../views/person/UserInfoView.vue'
import SuggestionsView from '../views/person/SuggestionsView.vue'
import AddSuggestionView from '../views/person/AddSuggestionView.vue'
import ScoreInfoView from '../views/person/ScoreInfoView.vue'
import AddressListView from '../views/person/AddressListView.vue'
import MyOrderListView from '../views/person/MyOrderListView.vue'
import ConsultationView from '../views/person/ConsultationView.vue'
import MyOrderInfoView from '../views/person/MyOrderInfoView.vue'
import EvaluateOrderListView from '../views/person/EvaluateOrderListView.vue'
import ServiceListView from '../views/person/ServiceListView.vue'
import ServiceInfoView from '../views/person/ServiceInfoView.vue'
import MyServiceOrderInfo from '../views/person/MyServiceOrderInfo.vue'
import ConfimOrderVIew from '../views/ConfimOrderVIew.vue'
import Register from '../views/Register.vue'
import CellsLineInfo from '../views/CellsLineInfo.vue'
import ProductInfo from '../views/ProductInfo.vue'
import BuyProductInfo from '../views/BuyProductInfo.vue'
import Pay from '../views/Pay.vue'
import PostDetail from '../views/PostDetail.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/register',
    name: 'register',
    component: Register
  }, {
    path: '/',
    name: 'shop',
    component: ShopView
  },

  {
    path: '/cellsline/:id',
    name: 'cellsline',
    component: CellsLine
  },

  {
    path: '/personcenter',
    name: 'personcenter',
    component: PersonCenter,
    children: [{
        path: '/',
        name: 'usercenter',
        component: UserCenter,
      },
      {
        path: '/userinfo',
        name: 'userinfo',
        component: UserInfoView,
      },
      {
        path: '/suggestionsview',
        name: 'suggestionsview',
        component: SuggestionsView,
      },
      {
        path: '/addsuggestion/:id',
        name: 'addsuggestion',
        component: AddSuggestionView,
      },
      {
        path: '/scoreinfoview',
        name: 'scoreinfoview',
        component: ScoreInfoView,
      },
      {
        path: '/addresslistview',
        name: 'addresslistview',
        component: AddressListView,
      },
      {
        path: '/myorderlistview',
        name: 'myorderlistview',
        component: MyOrderListView,
      },
      {
        path: '/consultationview',
        name: 'consultationview',
        component: ConsultationView,
      },
      {
        path: '/myorderinfoview',
        name: 'myorderinfoview',
        component: MyOrderInfoView,
      },
      {
        path: '/evaluateorder',
        name: 'evaluateorder',
        component: EvaluateOrderListView,
      },
      {
        path: '/servicelist',
        name: 'servicelist',
        component: ServiceListView,
      },
      {
        path: '/serviceinfo/:id',
        name: 'serviceinfo',
        component: ServiceInfoView,
      },
      {
        path: '/myserviceorderinfo/:id',
        name: 'myserviceorderinfo',
        component: MyServiceOrderInfo,
      }
    ]
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView,

  },
  {
    path: '/shop',
    name: 'shop',
    component: ShopView,

  },
  {
    path: '/shopcart',
    name: 'shopcart',
    component: ShopCartView,

  },
  {
    path: '/confimorder',
    name: 'confimorder',
    component: ConfimOrderVIew,

  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,

  },
  {
    path: '/cellslineinfo/:id',
    name: 'cellslineinfo',
    component: CellsLineInfo,

  },
  {
    path: '/productinfo/:id',
    name: 'productinfo',
    component: ProductInfo,

  },
  {
    path: '/buyproduct/:id',
    name: 'buyproduct',
    component: BuyProductInfo,

  },
  {
    path: '/postdetail/:id',
    name: 'postdetail',
    component: PostDetail,
  }
]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'cellslineinfo' || to.path.includes('/cellslineinfo')) {
      return { x: 0, y: 0 }
    }
    return savedPosition || { x: 0, y: 0 }
  }
})

// 4. 创建和挂载根实例。(在main.js里继续挂载)
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



export default router